import { render, staticRenderFns } from "./IconLike.vue?vue&type=template&id=0bd0fda6"
import script from "./IconLike.vue?vue&type=script&lang=js"
export * from "./IconLike.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports